<template>
  <footer>
    <div class="ecogas-footer">
      <div class="default-container">
        <!--<section class="paragrafo-come-funziona fiera-banner --footer">
      <img :src="'/home/fiera-febbraio.png'" />
    </section>-->
        <div class="ecogas-footer__flex">
          <div class="ecogas-footer__flex__div">
            <img
              :src="
                require('@/assets/components/EcogasFooter/Logo_RondaEngineering.svg')
              "
              alt="Ronda Logo"
              width="170px"
              height="73px"
            />
            <p v-html="$t('testoFooter')" />
            <p class="links" v-html="$t('testoFooter2nd')" />
            <p class="links underlinead" style="margin-top: 1rem">
              <router-link
                :to="{ name: `${lang}-cookie-policy`, params: { lang } }"
              >
                {{ $t("testoFooterPrivacyCookie") }}
              </router-link>
              <span style="height: 20px; display: block" />
              <!-- <router-link :to="{ name: `${lang}-condizioni-generali`, params: { lang } }">
                {{ $t('testoFooterCondizioniVendita') }}
              </router-link> -->
            </p>
          </div>
          <div class="ecogas-footer__flex__div">
            <p
              class="footer-details-title"
              v-html="$t('testoFooterDettagli')"
            />
            <p style="margin-top: 2rem">{{ $t("testoFooterDettagliTesto") }}</p>
            <LinkCta
              :to="{ name: `${lang}-richiesta-contatti`, params: { lang } }"
              :label="$t('testoFooterDettagliCta')"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="ecogas-footer-2nd">
      <div class="default-container">
        <ul>
          <li>
            ©{{ currentYear }} P.I. 02510300243 C.F. - 02510300243 - REA VI
            236366
          </li>
          <li>
            <a href="https://www.quamm.it/" target="_blank">quamm.it</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import LinkCta from '@/components/LinkCta'

export default {
  props: {
    lang: {
      type: String,
      required: true
    }
  },
  components: {
    LinkCta
  },
  computed: {
    currentYear: {
      get () {
        return new Date().getFullYear()
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";
@import "../assets/mixins/typo";
.ecogas-footer-2nd {
  background-color: #4d4d4d;
  padding: 30px 0;
  @media #{$large_mq} {
    padding: 40px 0;
  }
  ul {
    display: flex;
    justify-content: space-between;
  }
  li,
  li a {
    font-size: 0.85rem;
    font-family: "IBM Plex Mono", sans-serif;
    font-weight: 400;
    color: #fff;
    line-height: 1.3;
    text-decoration: none;
    @media #{$large_mq} {
      font-size: 0.9rem;
    }
    @media #{$xlarge_mq} {
      font-size: 0.95rem;
    }
    @media #{$xxlarge_mq} {
      font-size: 1rem;
    }
  }
}
.ecogas-footer {
  background-color: #343434;
  padding: 100px 0 60px;

  text-align: center;

  .ecogas-footer__flex {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @media #{$large_mq} {
      flex-wrap: nowrap;
    }

    .ecogas-footer__flex__div {
      width: 100%;
      margin: 1rem 0;
      text-align: center;

      @media #{$large_mq} {
        width: 50%;
        margin: 0 auto;
        text-align: left;
      }
    }
  }

  @media #{$medium_mq} {
    padding: 140px 0 100px;
  }
  @media #{$large_mq} {
    padding: 180px 0 140px;
  }
  @media #{$xlarge_mq} {
    padding: 220px 0 200px;
  }

  p {
    text-align: center;
    @media #{$large_mq} {
      text-align: left;
    }
    font-size: 0.9rem;
    font-family: "IBM Plex Mono", sans-serif;
    font-weight: 400;
    color: #9c9c9c;
    line-height: 1.4;
    margin: 2rem 0 3rem;
    @media #{$medium_mq} {
      font-size: 0.95rem;
    }
    @media #{$large_mq} {
      font-size: 1.05rem;
    }
    @media #{$xlarge_mq} {
      font-size: 1.15rem;
    }
    @media #{$xxlarge_mq} {
      font-size: 1.25rem;
    }
  }

  .links a {
    font-size: 0.9rem;
    font-family: "IBM Plex Mono", sans-serif;
    font-weight: 400;
    color: #9c9c9c;
    line-height: 1.4;
    margin: 2rem 0;
    text-decoration: none;
    transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);

    @media #{$medium_mq} {
      font-size: 0.95rem;
    }
    @media #{$large_mq} {
      font-size: 1.05rem;
    }
    @media #{$xlarge_mq} {
      font-size: 1.15rem;
    }
    @media #{$xxlarge_mq} {
      font-size: 1.25rem;
    }
  }

  .links.underlinead a {
    border-bottom: 1px solid #9c9c9c;
  }
  .links.underlinead a:hover {
    border-bottom: 1px solid #fff;
  }

  .links a:hover {
    color: #fff;
  }
  .footer-details-title {
    font-size: 1.85rem;
    font-family: "IBM Plex Sans Condensed", sans-serif;
    font-weight: 300;
    color: #fff;
    line-height: 1.3;
    margin: 2rem 0;
    text-decoration: none;
    @media #{$medium_mq} {
      font-size: 2rem;
    }
    @media #{$large_mq} {
      font-size: 2.5rem;
    }
    @media #{$xlarge_mq} {
      font-size: 2.85rem;
    }
    @media #{$xxlarge_mq} {
      font-size: 3.125rem;
    }
  }

  .fiera-banner.--footer {
    margin: -100px auto 100px;
  }
  .fiera-banner.--footer img {
    padding: 0px 1.925rem 0;
    display: block;
    margin: auto;
    max-width: 100%;
    @media #{$small_mq} {
      padding: 50px 1.925rem 0;
    }
  }
}
</style>
